import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkVietNam } from '@src/utils/checkCountry';
import Text from '../Shared/Text';
import {
  formatNumberWithSuffix,
  formatPrice,
  getPackageTopUp,
} from '../../../../../services/package';
import CheckOrCross from '../Shared/CheckOrCross';

const PriceTopUp = ({ pkg, packages }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const topUpPackage = getPackageTopUp(pkg, packages);
  const isVietNam = checkVietNam();
  const pricePerCredits = (
    <div
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{
        __html: t('pricePerCredits', {
          price: formatPrice({
            vndPrice: topUpPackage?.vndPricePerUnit,
            usdPrice: topUpPackage?.usdPricePerUnit,
            isVietNam,
            language,
          }),
          credits: formatNumberWithSuffix(
            +topUpPackage?.creditsPerUnit,
            language,
          ),
        }),
      }}
    />
  );

  return !topUpPackage ? (
    <CheckOrCross isCheck={false} />
  ) : (
    <Text html={pricePerCredits} />
  );
};

const purchaseAdditionalCreditsFeatures = ({ packages, activePackages }) =>
  packages.map((pkg) => (
    <PriceTopUp key={pkg.code} pkg={pkg} packages={activePackages} />
  ));

export default purchaseAdditionalCreditsFeatures;
